import { useTranslation } from 'react-i18next';
import { EditorDefaultSidePanelType, setActiveSidePanel } from '../../../grid/reduxStore/blockStyleSettingsSlice.ts';
import { SecondaryMenu, SecondaryMenuTrigger } from '../../component/index.ts';

import { useAppDispatch, useAppSelector } from 'components/editor/grid/reduxStore/Store.ts';
import { useContext, useState } from 'react';
import { selectTextDefaultStyles, TextDefaultStyleTypesIdentifier } from '../../../grid/reduxStore/textDefaultStylingSlice.ts';
import { SidePanelAccordion } from '../../component';
import type { defaultStyles } from '../useAccordionData.tsx';
import useAccordionData from '../useAccordionData.tsx';
import Box from '@mui/material/Box';
import { combineDefaultStyles } from '../combineDefaultStyles.ts';
import { DocumentSettingsContext } from '../../DocumentSettings/DocumentDesignSettings/DocumentSettingsContext.tsx';

export function DefaultStyleSettings() {
  const dispatch = useAppDispatch();
  const textDefaultStyles = useAppSelector(selectTextDefaultStyles);

  const { updateTextDefaultStyle } = useContext(DocumentSettingsContext);

  const defaultStyles: defaultStyles[] = combineDefaultStyles(textDefaultStyles);

  const accordionData = useAccordionData({
    defaultStyles,
    handleTextDefaultStyleUpdate: (payload) =>
      updateTextDefaultStyle({ ...payload, TextDefaultStyleTypes: TextDefaultStyleTypesIdentifier.DOCUMENT }),
  });

  const firstAccordionTitle = accordionData[0].title.toLowerCase().replace(/\s/g, '-');
  const [expandedSection, setExpandedSection] = useState<string>(firstAccordionTitle);

  const { t } = useTranslation();

  const handleBackButtonClick = () => {
    dispatch(setActiveSidePanel({ type: EditorDefaultSidePanelType.EDITOR_DEFAULT_SIDE_PANEL }));
  };

  const handleDefaultStyleClick = () => {
    dispatch(setActiveSidePanel({ type: EditorDefaultSidePanelType.TABLE_DEFAULT_STYLE_SETTINGS_PANEL }));
  };

  return (
    <SecondaryMenu
      testId={'default-styles-settings'}
      menuTitle={t('document.grid.default_styles.title')}
      backButtonOnClick={handleBackButtonClick}
      rowGap="0px"
    >
      {accordionData?.map((accordion, index) => (
        <SidePanelAccordion
          key={`accordion-${index}`}
          title={accordion.title}
          textStyleAccordion={accordion.textStyles}
          expanded={expandedSection}
          onChange={(value) => setExpandedSection(value)}
        />
      ))}
      <Box mt={2} width="100%">
        <SecondaryMenuTrigger
          ButtonText={t('document.grid.table.default_styles.edit_table_default_styles')}
          handleClick={handleDefaultStyleClick}
        />
      </Box>
    </SecondaryMenu>
  );
}
